export default __webpack_public_path__ + "static/media/hud.e32812f7.gif";